import { ButtonStyled } from '@bechtel/gds';
import styled from 'styled-components';

export const WorkPackageActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: ${({ theme }) => theme.spacings[600]};
  padding-right: ${({ theme }) => theme.spacings[600]};
`;

export const ButtonBlock = styled(ButtonStyled)`
  background-color: ${({ theme }) => theme.colors.red[700]};
  &:hover {
    background-color: ${({ theme }) => theme.colors.red[600]};
  }
  &:active {
    background-color: ${({ theme }) => theme.colors.red[800]};
  }
`;
